var React = require('react');

function AnglePatternInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"className":"angle","x":"-20%","width":"125%","height":"70","transform":"rotate(4 800 80)","key":0}),React.createElement("use",{"className":"pattern","xlinkHref":"#centre-pattern-root","x":"70","y":"-55","height":"144","key":1})]);
}

AnglePatternInline.defaultProps = {"viewBox":"0 0 800 90","preserveAspectRatio":"xMidYMin slice"};

module.exports = AnglePatternInline;

AnglePatternInline.default = AnglePatternInline;
